module.exports = __webpack_public_path__ + "img/thumbnail_Coyote_m_normal.6c33dac1.png";